import { AsyncPipe, NgComponentOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { type DynamicComponent } from '@bizzdesign/shared/dom-models';
import { DynamicToolbarService } from '@bizzdesign/shared/services';
import { delay, type Observable } from 'rxjs';

@Component({
  selector: 'bd-dynamic-toolbar',
  templateUrl: './dynamic-toolbar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgComponentOutlet, AsyncPipe],
})
export class DynamicToolbarComponent {
  private readonly dynamicToolbarService = inject(DynamicToolbarService);

  readonly toolbar$: Observable<DynamicComponent | undefined> =
    this.dynamicToolbarService.activeToolbar$.pipe(delay(0));
}
